
import { GLOBAL_MSG } from '../mutation-types';
import axios from 'axios';

const base = {
	namespaced: true,	
	state: {
		msg: 0
	},
	mutations: {
		[GLOBAL_MSG] (state ,payload) {
			console.log('payload: ',payload)
			state.msg = payload.qty;
		}
	},
	actions: {
		increment (context) {
		  context.commit('increment')
		},
		async notice( { commit } ){
			const res = await axios.get('/baozusao/api/lease/notice/unread');
			commit(GLOBAL_MSG, res.data.body)
		}
	}
}
export default base;